import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const BottomNavigation = () => {
  const location = useLocation();
  let loc = location?.pathname?.split("/")[1];
  const navigate = useNavigate();
  const setCasinoModal = useContextSelector(AuthContext, (ctx) => {
    return ctx.setCasinoModal;
  });
  return (
    <nav>
      <ul className="mini-lobby">
        <li
          onClick={
            () => setCasinoModal(true)
            // window.location.replace("/casino?type=casino&provider=PLAY%20TECH")
          }
          id="mini"
          className="main-nav"
        >
          <div className="ui-link mini-lobby-a">
            <img
              className="icon-promote"
              src={require("../../assets/images/promot.gif")}
              alt="mini"
            />
          </div>
        </li>
        <li
          onClick={() => window.location.replace("/")}
          id="home"
          className={loc == "sports-sky" ? "select" : ""}
        >
          <div neua="Home" className="ui-link mini-lobby-a">
            <img
              className="icon-home"
              src={require("../../assets/images/transparent.gif")}
            />
            Home
          </div>
        </li>
        <li
          onClick={() => navigate("/inplay-sky")}
          id="inPlay"
          className={loc == "inplay-sky" ? "select" : ""}
        >
          <div neua="In-Play" className="ui-link mini-lobby-a">
            <img
              className="icon-inplay"
              src={require("../../assets/images/transparent.gif")}
            />
            In-Play
          </div>
        </li>
        <li
          onClick={() => navigate("/sports-sky-new")}
          id="sports"
          className={loc == "sports-sky-new" ? "select" : ""}
        >
          <div neua="Sports" className="ui-link mini-lobby-a">
            <img
              className="icon-sports"
              src={require("../../assets/images/transparent.gif")}
            />
            Sports
          </div>
        </li>

        <li
          onClick={() => navigate("/favourite-sky")}
          className={loc == "favourite-sky" ? "select" : ""}
          id="multiMarket"
        >
          <div className="ui-link mini-lobby-a">
            <img
              className="icon-pin"
              src={require("../../assets/images/transparent.gif")}
            />
            Multi Markets
          </div>
        </li>
        <li
          onClick={() => navigate("/account-sky")}
          className={loc == "account-sky" ? "select" : ""}
          id="account"
        >
          <div className="ui-link mini-lobby-a">
            <img
              className="icon-account"
              src={require("../../assets/images/transparent.gif")}
            />
            Account
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default BottomNavigation;
